/**
 * Platform bank accounts (platform admin) — holds subscription receipts.
 * Talks to /api/platform-banks. snake_case responses unwrapped from ApiResponse.
 */
import ApiService from './api.service';

const unwrap = (res) => (res && res.data ? res.data.data : null);

const PlatformBankService = {
  list: async () => unwrap(await ApiService.get('/api/platform-banks')) || [],
  get: async (id) => unwrap(await ApiService.get(`/api/platform-banks/${id}`)),
  create: async (data) => unwrap(await ApiService.post('/api/platform-banks', data)),
  update: async (id, data) => unwrap(await ApiService.put(`/api/platform-banks/${id}`, data)),
  remove: async (id) => ApiService.delete(`/api/platform-banks/${id}`),
  setActive: async (id, active) =>
    unwrap(await ApiService.put(`/api/platform-banks/${id}/active?active=${active}`, {})),
  getTransactions: async (id, params = {}) => {
    const res = await ApiService.get(`/api/platform-banks/${id}/transactions`, { params });
    // Page envelope: data.data is the Spring Page object
    return res && res.data ? res.data.data : null;
  },

  formatMoney: (amount, currency = 'AED') => {
    if (amount == null || isNaN(amount)) return '—';
    return new Intl.NumberFormat('en-AE', { style: 'currency', currency }).format(amount);
  },
};

export default PlatformBankService;
